/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespConsumerSourcingModalLoader_item = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespConsumerSourcingModal_item">;
    readonly " $refType": "PdpRespConsumerSourcingModalLoader_item";
};
export type PdpRespConsumerSourcingModalLoader_item$data = PdpRespConsumerSourcingModalLoader_item;
export type PdpRespConsumerSourcingModalLoader_item$key = {
    readonly " $data"?: PdpRespConsumerSourcingModalLoader_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespConsumerSourcingModalLoader_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespConsumerSourcingModalLoader_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespConsumerSourcingModal_item",
      "args": null
    }
  ]
};
(node as any).hash = 'e5bdfe645b11f89bc7ab401dd9e2105a';
export default node;
